import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=884a864c&scoped=true&"
import script from "./text-input.vue?vue&type=script&lang=js&"
export * from "./text-input.vue?vue&type=script&lang=js&"
import style0 from "./text-input.vue?vue&type=style&index=0&id=884a864c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884a864c",
  null
  
)

export default component.exports